import { Injectable } from '@angular/core';

import { DeleteCommandService } from 'pbc.angular';

import { IDeleteReisekostenabrechnungRequest, IDeleteReisekostenabrechnungResponse } from 'fa-kt.types';

@Injectable({
  providedIn: 'root',
})
export class DeleteReisekostenabrechnungCommandService extends DeleteCommandService<IDeleteReisekostenabrechnungRequest, IDeleteReisekostenabrechnungResponse> {
  readonly route = 'finanzen/reisekostenabrechnung';
}
